var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors && _vm.errors.length)?_c('div',{staticClass:"bcx-error-text"},[_vm._v(" "+_vm._s(_vm.errors.map(ve => ve.$message).join(' '))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }